<template>
  <v-content>
    <v-container container--fluid fill-height>
      <notification-dialog v-model="dialog" :title="notification.title" :message="notification.message" />
      <keep-alive include="TicketList">
        <router-view />
      </keep-alive>
    </v-container>
  </v-content>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CoreView',

  data: () => ({
    dialog: false
  }),

  computed: {
    ...mapGetters({
      systemNotification: 'notification/systemNotification'
    }),

    notification() {
      if (this.systemNotification) {
        return {
          title: this.systemNotification.type === 'error' ? 'Ошибка' : 'Сообщение',
          message: this.systemNotification.message
        }
      }
      return {
        title: null,
        message: null
      }
    }
  },

  watch: {
    systemNotification(val) {
      this.dialog = !!val
    },

    async dialog(val) {
      if (!val) {
        await this.$store.dispatch('notification/resetSystemNotification')
      }
    }
  }
}
</script>
<style scoped>
.centered-text {
  text-align: center;
  margin: 0 10px 0 10px;
}

.banner-img {
  height: 130px;
}

@media (max-width: 1000px) {
  .banner-img {
    height: 200px;
  }
}
</style>